import React from 'react';
import image from './404.png';
import BackButton from './BackButton';

export default function NoPage() {
    return <div className="andrfw-link-list-container">
        <img src={image} alt="404"/>
        <BackButton/>
    </div>;
}